import React, { useRef } from "react";
import "./placeDetails.css";

import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import cafe from "../../images/icons/cafe.png";
import InputBox from "../commonComponents/inputComponents/InputBox";

import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import { useShipping } from "../../contexts/ShippingContext";

export default function InCafeDetail() {
  const { inCafeSubmit } = useShipping();
  const tableRef = useRef();

  function handleSubmit(e) {
    e.preventDefault();

    const tableNum = tableRef.current.value;

    if (!tableNum || isNaN(tableNum)) {
      toast.error("لطفا شماره میز صحیح وارد کنید");
      return;
    }
    inCafeSubmit(tableNum);
  }

  return (
    <div className="place-type-container upper-container">
      <div className="detail-main-container">
        <div className="place-detail-text">
          <h2 className="middle-box-header">من اینجا..</h2>
          <div className="place-item detail-item">
            <span className="place-item-icon">
              <img src={cafe} alt="" className="cafe detail-cafe" />
            </span>
            در کافه هستم
          </div>

          <Link to="/shipping/type" className="detail-return-link">
            <span className="return-text detail-return-text">
              بازگشت
              <FontAwesomeIcon icon={faChevronLeft} className="return-icon" />
            </span>
          </Link>
        </div>
        <div className="detail-information">
          <form action="" className="detail-info-form" onSubmit={handleSubmit}>
            <InputBox
              gap="20px"
              label="شماره میز"
              name="table-number"
              ref={tableRef}
            />
            <button className="red-submit-btn detail-submit-btn">
              ثبت سفارش
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
